import { render } from "./TableHistoric.vue?vue&type=template&id=3b9bb52e"
import script from "./TableHistoric.vue?vue&type=script&lang=js"
export * from "./TableHistoric.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__